export default __webpack_public_path__ + "static/media/cf1.94813e98.jpg";